// src/components/Footer.js
import React from "react";
import { Container } from "react-bootstrap";
import { FaInstagram, FaTiktok } from "react-icons/fa"; // Importando ícones

const Footer = () => {
  return (
    <footer className="footer-container">
      <Container>
        <p>Amarante PetShop © 2024 - Todos os direitos reservados</p>
        <p>
          Endereço: Av. Benedito Santana, 54 - Novo Amarante, São Gonçalo do
          Amarante - RN
        </p>
        <p>
          Contato: <a href="tel:+5584988654827">(84) 98865-4827</a>
        </p>
        <div className="social-links">
          <a
            href="https://www.instagram.com/amarante_pet/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
          >
            <FaInstagram size={30} />
          </a>
          <a
            href="https://www.tiktok.com/@amarante.pet"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="TikTok"
          >
            <FaTiktok size={30} />
          </a>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
